<div
  class="academy-step-2 orgbrain-general-margin d-flex align-items-center !mt-4"
  [ngClass]="overrideClass"
>
  <button class="scroll-button" (click)="scrollLeft()" *ngIf="isScrollable()">
    <mat-icon class="!min-w-6">chevron_left</mat-icon>
  </button>
  <div class="d-flex gap-x-2 overflow-x-auto hide-scrollbar" #tabContainer>
    @for (tab of tabs; track $index) {
      @if (tab.show) {
        <div>
          <button
            (click)="changeTab($index)"
            obTrackClick="meeting-summary-tab-click"
            [trackProperties]="{ tabId: tab.id }"
            class="tab orgbrain-gray-text orgbrain-default-font {{ tab.class }}"
            [ngClass]="selectedTab === $index ? 'selected-tab' : ''"
            [id]="tab.id"
          >
            <div class="d-flex align-items-center gap-x-1 orgbrain-text relative">
              <p class="highlight">
                {{ tab.label }}
              </p>
              @if (tab.notifications) {
                <div
                  class="min-w-2 h-2 p-1 flex items-center justify-center bg-orgbrain-orange rounded-xl text-[10px] text-white font-bold absolute -top-2 -right-3 z-10"
                >
                  {{ tab.notifications }}
                </div>
                <div class="text-[6px] invisible">
                  {{ tab.notifications }}
                </div>
              }
            </div>
          </button>
        </div>
      }
    }
  </div>
  <button class="scroll-button" (click)="scrollRight()" *ngIf="isScrollable()">
    <mat-icon class="!min-w-6">chevron_right</mat-icon>
  </button>
</div>

<div class="orgbrain-border-top"></div>
@if (tabs[selectedTab]?.show && !showHiddenTabs) {
  <div [ngClass]="overrideTabClass + ' ' + tabs[selectedTab]?.tabWindowClassOverride">
    <ng-container *ngTemplateOutlet="tabs[selectedTab]?.template"></ng-container>
  </div>
}

<ng-content></ng-content>
